module.exports = __webpack_public_path__ + "img/dashboard-black.c04e99b8.svg";